/*
 * hf-selleasy-addons.js
 * -----------------------------------------------------------------------------
 * Fixes Selleasy pre-purchase add-ons not being added to cart (and the 10%
 * discount not applying) on product pages.
 *
 * ROOT CAUSE
 *   Selleasy's PPA widget adds its checked add-ons AND applies its discount code
 *   inside its own handler (ppaWidget.handleAddToCart), which it wires to the
 *   Add-to-Cart click. Qikify Sticky Cart binds its own handler to the product
 *   form (stamps it data-qsc-atc-bound="1") and calls stopPropagation on the
 *   click, so Selleasy's listener never fires. Result: the main product is added
 *   by Qikify, but the add-ons never are, and the 10% code is never applied.
 *
 * WHAT THIS DOES
 *   Listens for the Add-to-Cart click in the CAPTURE phase (before Qikify can
 *   stop propagation) and invokes Selleasy's OWN handleAddToCart routine. That
 *   adds the checked add-ons and applies the Selleasy discount exactly as Selleasy
 *   intends. It does NOT add the main product (Qikify still does that, so there's
 *   no double-add) and does NOT touch the discount logic (Selleasy owns it).
 *
 * WHY NOT JUST /cart/add.js?
 *   Adding the variants directly puts them in the cart but skips Selleasy's
 *   discount step, so the 10% never applies. Delegating to handleAddToCart keeps
 *   the items and the discount together.
 *
 * INSTALL
 *   1. Upload as a theme asset (assets/hf-selleasy-addons.js).
 *   2. Load on product pages AFTER the Selleasy widget script, e.g. before
 *      </body> in theme.liquid:
 *        {{ 'hf-selleasy-addons.js' | asset_url | script_tag }}
 *   3. Safe no-op when the Selleasy widget isn't present or nothing is checked.
 *
 * NOTES
 *   - Covers the on-page "Add to cart" button. The Qikify sticky-bar button lives
 *     in a shadow DOM and is not covered here; ask if you want that too.
 *   - If you ever remove Qikify, remove this script (Selleasy would fire natively
 *     again and this would double-trigger).
 * -----------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var MAIN_ATC_SELECTOR = 'form.product-form--single button[name="add"]';
  var WIDGET_SELECTOR   = 'lb-upsell-product-page-addon';
  var DEBOUNCE_MS       = 1000;

  var lastFire = 0;

  function runSelleasyAddToCart(ev) {
    // Only act when the Selleasy PPA widget and its handler are present.
    if (!document.querySelector(WIDGET_SELECTOR)) return;
    var components = window.lbUpsellComponents;
    var ppa = components && components.ppaWidget;
    if (!ppa || typeof ppa.handleAddToCart !== 'function') return;

    try {
      // Selleasy's own routine: adds the checked add-ons AND applies its discount.
      // It does not add the main product and does not preventDefault, so the
      // existing (Qikify) add-to-cart for the main product proceeds normally.
      ppa.handleAddToCart(ev);
    } catch (e) {
      if (window.console) console.warn('[hf-selleasy-addons] handleAddToCart failed', e);
    }
  }

  // CAPTURE phase (3rd arg = true) is required: Qikify calls
  // stopPropagation/stopImmediatePropagation on the click, so a bubble-phase
  // listener never receives it. Capture runs document -> target, before Qikify
  // can stop it. Do NOT change this to bubble phase.
  document.addEventListener('click', function (ev) {
    var target = ev.target;
    if (!target || !target.closest) return;
    if (!target.closest(MAIN_ATC_SELECTOR)) return;

    var now = Date.now();
    if (now - lastFire < DEBOUNCE_MS) return; // guard rapid double-clicks
    lastFire = now;

    runSelleasyAddToCart(ev);
  }, true);
})();